var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "url(#paint0_linear_2380_8437)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6868 4.44513L5.74111 4.49309L8.2163 6.96782L10.6915 4.49309C10.9166 4.26793 11.2817 4.26793 11.5069 4.49309C11.7147 4.70094 11.7307 5.02799 11.5548 5.25418L11.5069 5.3085L9.03215 7.78368L11.5069 10.2589C11.732 10.484 11.732 10.8491 11.5069 11.0743C11.299 11.2821 10.972 11.2981 10.7458 11.1222L10.6915 11.0743L8.2163 8.59953L5.74111 11.0743C5.51595 11.2994 5.15088 11.2994 4.92571 11.0743C4.71786 10.8664 4.70188 10.5394 4.87775 10.3132L4.92571 10.2589L7.40044 7.78368L4.92571 5.3085C4.70054 5.08333 4.70054 4.71826 4.92571 4.49309C5.13356 4.28525 5.46061 4.26926 5.6868 4.44513Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2380_8437",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#7E30E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#0072F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#67ADFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cd02982b006156b11f16f7600897bddd.svg";
export { ForwardRef as ReactComponent };